import { IConfigAPI } from '../../interface/config';

const usernameFromConfig = (configs: Array<Partial<IConfigAPI>>): string | undefined =>
    configs.map(config => config?.auth?.username).filter(username => username)[0];

const module = {
    usernameFromConfig,
};

export default module;
